import React from "react";
import { Link } from "gatsby";
import cx from "classnames";
import JobPost from "~/models/job-post";
import ChevronRight from "~/views/identity/chevron-right";

type Props = {
  jobPost: JobPost;
  className?: string;
};

function JobPostCard({ jobPost, className }: Props) {
  return (
    <Link
      to={`/jobs/${jobPost.id}/`}
      className={cx(
        className,
        "bg-white flex flex-col rounded-2xl p-4 gap-5 border border-[#F2F2F2]"
      )}>
      <div
        className="flex items-start gap-4 p-3 rounded-lg bg-neutral-99 flex-1"
        style={{
          backgroundColor:
            jobPost.company.logo.dominantColor?.replace(/,[^,]+\)/, ",0.08)") ||
            "",
        }}>
        <div className="min-w-[82px] w-[82px] h-[82px] p-1 flex rounded-full justify-center items-center overflow-hidden bg-white">
          <img
            src={jobPost.company.logo.imgix?.url}
            alt={jobPost.company.name}
            loading="eager"
            className="w-full h-full object-contain"
          />
        </div>

        <div className="flex-1">
          <div className="flex flex-col gap-3">
            <div className="space-y-2 sm:space-y-3 pt-2">
              <div className="text-[14px] leading-[1.2em] font-semibold">
                {jobPost.company.name}
              </div>
              <h3 className="text-base sm:text-lg font-bold leading-[1.4em]">
                {jobPost.title}
              </h3>
            </div>

            <div className="hidden md:flex flex-wrap gap-2">
              {jobPost.labels && jobPost.labels.length > 0
                ? jobPost.labels.slice(0, 2).map((label, index) => (
                    <div
                      key={index}
                      className="bg-white text-neutral-30 text-4xs font-normal leading-[1.2em] py-2 px-3 rounded-full font-medium">
                      {label.name}
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center">
        <div className="flex flex-col">
          <div className="text-lg font-bold">
            {!!jobPost.minimumSalary && (
              <span>{`${jobPost.minimumSalary}万円`}</span>
            )}

            {(!!jobPost.minimumSalary || !!jobPost.maximumSalary) && (
              <span> - </span>
            )}

            {!!jobPost.maximumSalary && (
              <span>{`${jobPost.maximumSalary}万円`}</span>
            )}

            {!jobPost.minimumSalary && !jobPost.maximumSalary && (
              <span>非公開</span>
            )}
          </div>
          <div className="text-[15px] text-[#929095]">
            {jobPost.locations.map((location) => location.name).join("/")}
          </div>
        </div>

        <div className="shrink-0 border border-black rounded-full px-6 py-2 text-[15px] font-medium transition-colors hover:bg-black hover:text-white flex items-center gap-2">
          求人詳細
          <ChevronRight width={6} height={12} color="currentColor" />
        </div>
      </div>
    </Link>
  );
}

export default JobPostCard;
